import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export function isGoogleLink(url) {
  return /drive\.google\.com|photos\.app\.goo\.gl|photos\.google\.com/.test(url || "");
}

/** Appelé au blur d'un champ URL : convertit automatiquement les liens Google Drive/Photos. */
export async function resolveGoogleLink(url, apply, kind = "") {
  if (!isGoogleLink(url)) return;
  try {
    const { data } = await api.post("/admin/resolve-link", { url, kind });
    if (data.url && data.url !== url) {
      apply(data.url);
      toast.success("Lien Google converti en adresse directe");
    }
  } catch (err) {
    toast.error(formatApiError(err, "Lien Google illisible — vérifiez que le partage est public."));
  }
}

export const GOOGLE_HINT =
  "Vous pouvez coller un lien Google Drive ou Google Photos (partage « Toute personne disposant du lien ») — il sera converti automatiquement.";
